
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalCharging100 as ObiBatteryHorizontalCharging100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-charging-100.js';
 
 
 

 
 export const ObiBatteryHorizontalCharging100 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-charging-100',
   elementClass: ObiBatteryHorizontalCharging100Element,
   events: {
     
   }
  });
 
 